<template>
  <div class="text-sn-gray-900">
    <div class="pb-4 font-bold md:text-xl md:pb-10">
      {{ tr('components.sales.summary.title') }}
    </div>

    <div class="space-y-2 text-sm md:text-base md:space-y-4">
      <div class="flex justify-between font-bold">
        <div class="mr-3">
          {{ tr('components.sales.summary.totalValue') }}
        </div>
        <div class="flex-shrink-0">
          {{ purchase.voucherDenominationCents | formatCurrency(currency) }}
        </div>
      </div>

      <div class="flex justify-between">
        <div class="mr-3">
          {{ tr('components.sales.summary.totalDue') }}
        </div>
        <div class="flex-shrink-0">
          {{ $store.getters['sales/amountToPayInCents'] | formatCurrency(currency) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VoucherAmountSummary from '~brand-components/base/sale/voucher-amount-summary'

export default VoucherAmountSummary.extend()
</script>
